var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"peligro"},[(_vm.colorBar)?_c('img',{staticClass:"peligro--colorbar",attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }